"use client";

import { useState, useEffect } from 'react';

export function InstallPwaButton({ isLight = false }: { isLight?: boolean }) {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(() => {
    if (typeof window !== 'undefined' && (window as any).deferredPwaPrompt) {
      return (window as any).deferredPwaPrompt;
    }
    return null;
  });

  useEffect(() => {
    if (typeof window !== 'undefined' && (window as any).deferredPwaPrompt) {
      setDeferredPrompt((window as any).deferredPwaPrompt);
    }
    const handler = (e: any) => {
      e.preventDefault();
      if (typeof window !== 'undefined') (window as any).deferredPwaPrompt = e;
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
       alert("Your browser doesn't support automatic installation, or it is already installed. You can install it manually from your browser menu (e.g. Share -> Add to Home Screen, or Install App in the address bar).");
       return;
    }
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
      if (typeof window !== 'undefined') (window as any).deferredPwaPrompt = null;
    }
  };

  return (
    <button 
      onClick={handleInstallClick} 
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '0.5rem 1rem',
        background: isLight ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.05)',
        border: isLight ? '1px solid rgba(0,0,0,0.1)' : '1px solid rgba(255,255,255,0.1)',
        borderRadius: '6px',
        color: isLight ? '#09090b' : 'white',
        cursor: 'pointer',
        fontSize: '0.85rem',
        fontWeight: 500,
        transition: 'all 0.2s',
        marginTop: '1rem',
        marginLeft: 'auto',
        marginRight: 'auto'
      }}
      onMouseEnter={(e) => e.currentTarget.style.background = isLight ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.1)'}
      onMouseLeave={(e) => e.currentTarget.style.background = isLight ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.05)'}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="7 10 12 15 17 10"></polyline>
        <line x1="12" y1="15" x2="12" y2="3"></line>
      </svg>
      Install App
    </button>
  );
}
